import { Stack, IconButton, Tooltip } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';

import { useNavigate } from 'react-router-dom';
import { ITaskTypes } from './taskTypes-utils';
import { Delete } from '@mui/icons-material';
import { useState } from 'react';
import TaskTypeDeleteModal from './TaskTypesDeleteModal';

interface Ownprops {
  taskTypes: ITaskTypes;
  hasEditPermission?: boolean;
  hasDeletePermission?: boolean;
}

const TaskTypesActionButton = ({ taskTypes, hasEditPermission, hasDeletePermission }: Ownprops) => {
  const { id } = taskTypes;

  const navigate = useNavigate();
  const [open, setOpen] = useState(false)

  const goToTaskTypesForm = () => navigate(`/service-task/${id}`);
  const goToModalDelete = () => setOpen(true);
  
  return (
    <Stack direction='row' gap={1}>
      {hasEditPermission &&
        <Tooltip title='Edit' placement='top'>
          <IconButton color='primary' aria-label='edit' onClick={goToTaskTypesForm}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      }
      {hasDeletePermission &&
        <Tooltip title='Delete' placement='top'>
          <IconButton color='warning' aria-label='delete' onClick={goToModalDelete}>
            <Delete />
          </IconButton>
        </Tooltip>
      }
      <TaskTypeDeleteModal setOpen={setOpen} open={open} taskTypes={taskTypes} />
    </Stack>
  );
};

export default TaskTypesActionButton;
